import { useState } from 'react'
import { useTheme } from '~/hooks/use-theme'
import type { TLinkSizes } from '../types'

export const useLinkVariants = () => {
  const theme = useTheme()
  const [pressed, setPressed] = useState(false)
  const [linkFocus, setLinkFocus] = useState(false)

  const linkSizeMapping: Record<TLinkSizes, number> = {
    md: theme.sizingMedium,
    ml: theme.sizingMediumlarge,
  }

  return {
    linkSizeMapping,
    pressed,
    setPressed,
    linkFocus,
    setLinkFocus,
  }
}
